import { useNavigate, useParams } from 'react-router-dom';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import FormAddEditOptionGroup from '../../components/optionGroups/FormAddEditOptionGroup';
import OptionValueManager from '../../components/optionGroups/Values/OptionValueManager';
import { useGetOptionGroupById } from '../../hooks/optionGroups/useGetOptionGroupById';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const EditOptionGroup = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { i18n } = useTranslation();
    const isArabic = i18n.language?.startsWith('ar');

    const { optionGroup, isLoading, error } = useGetOptionGroupById(id);

    const handleSuccess = () => {
        navigate('/option-groups');
    };

    if (isLoading) {
        return (
            <WrapperSection>
                <GlobalBreadcrumbs />
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    if (error || !optionGroup) {
        return (
            <WrapperSection>
                <GlobalBreadcrumbs />
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <Typography color="error">
                        {isArabic ? 'حدث خطأ في تحميل البيانات' : 'Error loading data'}
                    </Typography>
                </Box>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditOptionGroup
                currentData={optionGroup}
                isEdit={true}
                onSubmitSuccess={handleSuccess}
            />

            {/* Option Values Management */}
            <OptionValueManager optionGroup={optionGroup} />
        </WrapperSection>
    );
};

export default EditOptionGroup;
